<template>
    <div>
        <div class="container">
            <div class="row">
                <div v-for="item in data.slice(8, 15)" :key="item.id" class="mb-4 col-sm-6 col-md-6 col-lg-12">   
                    <div class="card">
                        <hr class="line"
                            :style="{ backgroundColor: getProkuroriaVar(item.prokuroria), color: getProkuroriaVar(item.prokuroria) }" />
                        <!-- <img src="../../assets/lajm1.jpg" /> -->
                        <div class="card-body">
                            <!-- <p class="date_post">{{item.data_postimit}}</p> -->
                            <div class="mt-auto text-start boxchips">
                                <prokuroria-chips :item="item.prokuroria" />
                            </div>
                            <h5 @click="redirectToPost(item.id)" class="card-title" :title="item.titulli">{{
                                item.titulli }}</h5>
                            <!-- <a :href="item.meshume" class="card-link">Më shumë &nbsp;<font-awesome-icon icon="fa-solid fa-arrow-right" /></a> -->
                        </div>
                    </div>
                </div>
             </div>
        </div>
    </div>

</template>
<script>
import ProkuroriaChips from './ProkuroriaChips.vue';
export default {
  components: { ProkuroriaChips },
    data(){
        return {

        }
    },

    props: ['data'],
    computed: {
        chunkedData(){
            const chunkSize = 3;
            const limitedData = this.data.slice(8, 15); // Limit to 6 items
            return limitedData.reduce((acc, item, index) =>{
                const chunkIndex = Math.floor(index / chunkSize);
                if (!acc[chunkIndex]) acc[chunkIndex] = [];
                acc[chunkIndex].push(item);
                return acc;
            }, []);
        },
    },

    methods: {
        redirectToPost(postId){
            this.$router.push(`/artikulli/${postId}`);
        },
        getProkuroriaVar(prokuroria){
            switch (prokuroria)
            {
                case 'Sistemi Prokurorial i Kosovës':
                    return 'var(--color-system)';
                case 'Këshilli Prokurorial i Kosovësl':
                    return 'var(--color-kpk)';
                case "Zyra e Kryeprokurorit te Shtetit":
                    return 'var(--color-zkpsh)';
                case 'Prokuroria e Apelit':
                    return 'var(--color-pa)';
                case 'Prokuroria Speciale':
                    return 'var(--color-ps)';
                case 'Prokuroria Themelore Prishtine':
                    return 'var(--color-prishtine)';
                case 'Prokuroria Themelore Prizren':
                    return 'var(--color-prizren)';
                case 'Prokuroria Themelore Ferizaj':
                    return 'var(--color-ferizaj)';
                case 'Prokuroria Themelore Peje':
                    return 'var(--color-peje)';
                case 'Prokuroria Themelore Mitrovice':
                    return 'var(--color-mitrovice)';
                case 'Prokuroria Themelore Gjilan':
                    return 'var(--color-gjilan)';
                case 'Prokuroria Themelore Gjakove':
                    return 'var(--color-gjakove)';
                case 'Sekretariati':
                    return 'var(--color-sekretariati)';
                default:
                    return '#0000';
            }
        }
    }
}
</script>
<style scoped>
.card-body {
    background-color: #FFFFFF;
    padding: 16px;
    border-radius: 6px !important;
    height: 107px;
}

.card {
    margin: 0 !important;
    border: transparent !important;
    position: relative !important;
}

.card-title {
    line-height:15px;
    font-size: 14px;
    font-weight: 500;
    color: #101828;
    letter-spacing: -0.2%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-text span {
    color: #2C3F5E;
    font-size: 12px;
    line-height: 19px;
    letter-spacing: 0%;
    font-weight: 600;
    background-color: #EEF2F9;
    padding: 2px 12px;
    border-radius: 6px;
}

.container {
    overflow: hidden;
    height: 890px;
}

.line {
    position: absolute;
    height: 3px;
    width: 60px;
    border-radius: 6px;
    opacity: 1;
    margin-left: 16px;
    margin-top: 0;
}

.boxchips {
    position: absolute;
    bottom: 15px;
}

h5{
    cursor:pointer !important;
}

@media(max-width:991px){
    .container{
        margin-top:25px;
    }
}

</style>